import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter,
} from "@/components/ui/dialog";
import { AlertTriangle } from "lucide-react";

const KEYWORD = "verwijderen";

export function ConfirmDeleteDialog({ open, onOpenChange, title, description, onConfirm, testid }) {
  const [txt, setTxt] = useState("");
  const [busy, setBusy] = useState(false);
  const ok = txt.trim().toLowerCase() === KEYWORD;

  const close = (o) => { onOpenChange(o); if (!o) setTxt(""); };

  const handle = async () => {
    if (!ok || busy) return;
    setBusy(true);
    try {
      await onConfirm();
      close(false);
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={close}>
      <DialogContent data-testid={testid || "confirm-delete-dialog"}>
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-destructive">
            <AlertTriangle className="h-5 w-5" /> {title || "Weet je dit zeker?"}
          </DialogTitle>
          {description && <DialogDescription>{description}</DialogDescription>}
        </DialogHeader>
        <div className="space-y-2">
          <Label>Typ <span className="font-mono font-semibold text-foreground">verwijderen</span> en klik op OK om dit te doen.</Label>
          <Input value={txt} onChange={(e) => setTxt(e.target.value)} placeholder="verwijderen"
            autoFocus data-testid="confirm-delete-input"
            onKeyDown={(e) => { if (e.key === "Enter" && ok) handle(); }} />
        </div>
        <DialogFooter>
          <Button variant="ghost" onClick={() => close(false)}>Annuleren</Button>
          <Button variant="destructive" disabled={!ok || busy} onClick={handle} data-testid="confirm-delete-ok">
            {busy ? "Bezig…" : "OK, verwijderen"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
